import type { Sokekilde } from './sokekilde';

import { removeSensitiveContent } from '@helsenorge/core-utils/string-utils';
import { track } from '@helsenorge/framework-utils/amplitude';
import {
  BruktGlobalsok,
  EkspandertKiOppsummering,
  GittTilbakemeldingKiOppsummering,
  KlikketPaSokeresultat,
} from '@helsenorge/framework-utils/amplitude/ampli';

export const trackGlobalSearch = (params: {
  searchType: string;
  query: string;
  totalHits: number;
  isSummaryEnabled: boolean;
  sokekilde?: Sokekilde;
}): void =>
  track(
    new BruktGlobalsok({
      handling: 'navigere',
      objekt: 'globalsøk',
      soktype: params.searchType,
      sokeord: removeSensitiveContent(params.query),
      antallSokeresultat: params.totalHits,
      sokeOppsummering: params.isSummaryEnabled,
      sokekilde: params.sokekilde,
    })
  );

export const trackResultClick = (params: {
  searchType: string;
  query: string;
  totalHits?: number;
  position?: number;
  resultTag?: string;
  selectedResult: string;
  isSummaryEnabled: boolean;
  sokekilde?: Sokekilde;
  valgtSokeresultatPlassering: 'resultatliste' | 'ki-oppsummering';
}): void =>
  track(
    new KlikketPaSokeresultat({
      handling: 'navigere',
      objekt: 'sokeresultat',
      soktype: params.searchType,
      sokeord: removeSensitiveContent(params.query),
      antallSokeresultat: params.totalHits,
      sokeresultatPosisjon: params.position,
      sokeresultatTag: params.resultTag,
      valgtSokeresultat: params.selectedResult,
      sokeOppsummering: params.isSummaryEnabled,
      sokekilde: params.sokekilde,
      valgtSokeresultatPlassering: params.valgtSokeresultatPlassering,
    })
  );

export const trackPositiveFeedbackForSummary = (params: {
  searchType: string;
  query: string;
  totalHits?: number;
  isSummaryEnabled: boolean;
  sokekilde?: Sokekilde;
}): void =>
  track(
    new GittTilbakemeldingKiOppsummering({
      handling: 'gi tilbakemelding',
      objekt: 'ki-oppsummering',
      soktype: params.searchType,
      sokeord: removeSensitiveContent(params.query),
      antallSokeresultat: params.totalHits,
      sokeOppsummering: params.isSummaryEnabled,
      sokekilde: params.sokekilde,
      tilbakemeldingTekst: 'tommel opp',
    })
  );

export const trackNegativeFeedbackForSummary = (params: {
  searchType: string;
  query: string;
  totalHits?: number;
  isSummaryEnabled: boolean;
  sokekilde?: Sokekilde;
}): void =>
  track(
    new GittTilbakemeldingKiOppsummering({
      handling: 'gi tilbakemelding',
      objekt: 'ki-oppsummering',
      soktype: params.searchType,
      sokeord: removeSensitiveContent(params.query),
      antallSokeresultat: params.totalHits,
      sokeOppsummering: params.isSummaryEnabled,
      sokekilde: params.sokekilde,
      tilbakemeldingTekst: 'tommel ned',
    })
  );

export const trackExpandedSummary = (params: {
  searchType: string;
  query: string;
  totalHits?: number;
  isSummaryEnabled: boolean;
  sokekilde?: Sokekilde;
}): void => {
  track(
    new EkspandertKiOppsummering({
      handling: 'se',
      objekt: 'ki-oppsummering',
      soktype: params.searchType,
      sokeord: removeSensitiveContent(params.query),
      antallSokeresultat: params.totalHits,
      sokeOppsummering: params.isSummaryEnabled,
      sokekilde: params.sokekilde,
    })
  );
};
